<template>
  <component v-if="Base" :is="Base" :contractData="contractData" />
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
// 投資型基本資料輸入
import Base_Type1 from "./Item_IV/Base_Type1"; //1-1定期繳VL
import Base_Type2 from "./Item_IV/Base_Type2"; //1-2定期+超額VUL
import Base_Type3 from "./Item_IV/Base_Type3"; //1-3躉繳VL
import Base_Type4 from "./Item_IV/Base_Type4"; //1-4躉繳VA
import Base_Type5 from "./Item_IV/Base_Type5"; //1-5彈性繳VA
import Base_Type6 from "./Item_IV/Base_Type6"; //1-6定期+超額VA
import Base_Type7 from "./Item_IV/Base_Type7"; //1-7定期+彈性繳VL
import Base_Type8 from "./Item_IV/Base_Type8"; //1-8定期+彈性繳VA
export default {
  props: ["contractData"],
  components: {
    Base_Type1,
    Base_Type2,
    Base_Type3,
    Base_Type4,
    Base_Type5,
    Base_Type6,
    Base_Type7,
    Base_Type8,
  },
  data() {
    return {
      Base: "",
      hasAnnuity: "",
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      switch (this.contractData.saveData.mc_type) {
        case "1":
          this.Base = "Base_Type1";
          break;
        case "2":
          this.Base = "Base_Type2";
          break;
        case "3":
          this.Base = "Base_Type3";
          break;
        case "4":
          this.Base = "Base_Type4";
          this.hasAnnuity = true;
          break;
        case "5":
          this.Base = "Base_Type5";
          this.hasAnnuity = true;
          break;
        case "6":
          this.Base = "Base_Type6";
          this.hasAnnuity = true;
          break;
        case "7":
          this.Base = "Base_Type7";
          break;
        case "8":
          this.Base = "Base_Type8";
          this.hasAnnuity = true;
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contractItem {
  max-width: 904px;
  width: 100%;
  border-radius: 4px;
  border: solid 1px #53c480;
  &__index {
    padding: 15px;
    line-height: 1.38;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 700;
    color: #027a39;
    background-color: #e5f6ec;
  }
  &__title {
    width: 100%;
    display: flex;
    font-weight: 700;
    color: #027a39;
    background-color: #e5f6ec;
    border-top: solid 1px rgba(194, 196, 199, 0.8);
    & > div {
      border: solid 1px rgba(194, 196, 199, 0.8);
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 3px 7px;
    }
    & > div:nth-of-type(1) {
      min-height: 50px;
      width: 40%;
    }
    & > div:nth-of-type(2) {
      width: 6%;
    }
    & > div:nth-of-type(3) {
      width: 11%;
    }
    & > div:nth-of-type(4) {
      width: 13%;
    }
    & > div:nth-of-type(5) {
      width: 15%;
    }
    & > div:nth-of-type(6) {
      width: 15%;
    }
  }
  //主約
  &__MC {
    width: 100%;
    display: flex;
    color: #323a45;
    background-color: #fff;
    border-top: solid 1px rgba(194, 196, 199, 0.8);
    & > div {
      border: solid 1px rgba(194, 196, 199, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 3px 7px;
    }
    & > div:nth-of-type(1) {
      min-height: 50px;
      width: 40%;
    }
    & > div:nth-of-type(2) {
      width: 6%;
    }
    & > div:nth-of-type(3) {
      width: 11%;
    }
    & > div:nth-of-type(4) {
      width: 13%;
    }
    & > div:nth-of-type(5) {
      width: 15%;
    }
    & > div:nth-of-type(6) {
      width: 15%;
    }
  }
  //   附約
  &__SC {
    width: 100%;
    display: flex;
    color: #323a45;
    background-color: #f5f5f5;
    border-top: solid 1px rgba(194, 196, 199, 0.8);
    & > div {
      border: solid 1px rgba(194, 196, 199, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 3px 7px;
    }
    & > div:nth-of-type(1) {
      min-height: 50px;
      width: 40%;
    }
    & > div:nth-of-type(2) {
      width: 6%;
    }
    & > div:nth-of-type(3) {
      width: 11%;
    }
    & > div:nth-of-type(4) {
      width: 13%;
    }
    & > div:nth-of-type(5) {
      width: 15%;
    }
    & > div:nth-of-type(6) {
      width: 15%;
    }
  }
  &__discountDesc {
    border-top: solid 1px rgba(194, 196, 199, 0.8);
    line-height: 1.38;
    padding: 8px 10px;
  }
}
</style>
